import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid/Grid';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

export default function Footer() {
  return (
    <Box sx={{ bgcolor: '#00395D', py: 2 }}>
      <Container maxWidth="lg">
        <Grid container spacing={2} justifyContent="center">
          <Grid item xs={6} sm={3} sx={{ textAlign: 'center' }}>
            <Typography
              variant="subtitle2"
              fontWeight={700}
              color="#FFFFFF"
              gutterBottom
            >
              Company
            </Typography>
            <ul style={{ listStyle: 'none', padding: 0 }}>
              <li>
                <Link href="/disclaimer" variant="body2" color="#FFFFFF">
                  Disclaimer
                </Link>
              </li>
            </ul>
          </Grid>
          <Grid item xs={6} sm={3} sx={{ textAlign: 'center' }}>
            <Typography
              variant="subtitle2"
              fontWeight={700}
              color="#FFFFFF"
              gutterBottom
            >
              Support
            </Typography>
            <ul style={{ listStyle: 'none', padding: 0 }}>
              <li>
                <Link href="#" variant="body2" color="#FFFFFF">
                  Help
                </Link>
              </li>
            </ul>
          </Grid>
        </Grid>
        <Box sx={{ mt: 2, textAlign: 'center' }}>
          <Typography variant="body2" color="#FFFFFF">
            {'Copyright © '}
            <Link color="inherit" href="/">
              Erickson Senior Living
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}
